function removeByFieldValue<T extends anyObject>(arr: Array<T>, key: keyof T, value: any): Array<T> {
  const tmp = arr.slice();
  const index = tmp.findIndex((_) => _[key] === value);
  if (index > -1) tmp.splice(index, 1);
  return tmp;
}

export { removeByFieldValue };

